/// <reference path="./typings/index.d.ts" />

// 認証HOST
var APPROVEURL_HOST = '';
// 認証URL
var APPROVEURL_URL = 'loginMock.html';

// 契約者情報
var accountInfo = undefined;

// 再度認証フラグ(排他チェックエラー用)
var reAuthFlag = false;

// Loginオブジェクト
var Login = {

    // Casisクッキークリアの判定
    jumpToMsnLogin: function () {
        // 予約情報を初期化
        OLS.singleDeleteStorage("reservationInfo");
        
        console.warn("[auto]casis logout status:" + (onloadStatus.get("logout") == 1 ? "ok" : "error"));
        OLS.setSessionStorage("loginType","0");
        if (onloadStatus.get("logout") == 1) {
            Login.gotoLogin();
        } else {
            setTimeout(function(){
                console.warn("[wait 300]casis logout status:" + (onloadStatus.get("logout") == 1 ? "ok" : "error"));
                Login.gotoLogin();
            }, 300);
        }
    },

    // 移動機物品販売の端末MSNでログインする時、Casisクッキークリアの判定
    jumpToDeviceLogin: function () {
        console.warn("[auto]casis logout status:" + (onloadStatus.get("logout") == 1 ? "ok" : "error"));
        OLS.setSessionStorage("loginType","1");
        if (onloadStatus.get("logout") == 1) {
            Login.gotoLogin();
        } else {
            setTimeout(function(){
                console.warn("[wait 300]casis logout status:" + (onloadStatus.get("logout") == 1 ? "ok" : "error"));
                Login.gotoLogin();
            }, 300);
        }
    },

    // ログインする
    jumpToLogin: function () {
        if (params.sb == "Y") {
            Login.jumpToMsnLogin();
        } else {
            Login.jumpToDeviceLogin();
        }
    },

    // 認証URLに遷移する
    gotoLogin: function () {

        // ログイン前、画面選択状態を保存する
        Login.storePageStatus();
        // 遷移前にloadingを非表示
        hideLoading();
        // CASISに遷移
        if (UA.isSmartDevice && !reAuthFlag) {
            pageJumpImmediately(APPROVEURL_HOST + APPROVEURL_URL + '?v=' + new Date().getTime() + '&loginType=' + OLS.getSessionStorage("loginType"));
        } else {
            // 再度認証フラグの初期化
            reAuthFlag = false;
            // PCの場合強制id/pass認証にする
            pageJumpImmediately(APPROVEURL_HOST + APPROVEURL_URL + '?type=force' + '&v=' + new Date().getTime() + '&loginType=' + OLS.getSessionStorage("loginType"));
        }
    },

    // ログイン前、画面選択状態を保存する
    storePageStatus: function () {

        // 画面選択状態を保存する
        // 契約状況
        OLS.setSessionStorage("applType", $("[name='applType']:checked").val());
        // 年齢
        OLS.setSessionStorage("ageClass", $("[name='ageClass']:checked").val());
        // 受け取り方法
        OLS.setSessionStorage("receiptChgCtrl", $("[name='receiptChgCtrl']:checked").val());
        // 予約番号
        OLS.setSessionStorage("contractorReserveNo", $("#contractorReserveNo").val());
    },

    // ログイン後、ログイン前の画面選択状態をセットする
    setPageStatus: function () {

        // 画面選択状態をセットする
        // 契約状況
        $("#applType input[value='" + OLS.getSessionStorage("applType") + "']").click();
        // 年齢
        $("#ageClass input[value='" + OLS.getSessionStorage("ageClass") + "']").click().click();
        // 受け取り方法
        $("#receiptChgCtrl input[value='" + OLS.getSessionStorage("receiptChgCtrl") + "']").click().click();

    },

    // MSNより契約者情報を取得する
    getUserInfo: function () {
        var self = this;
        $.ajax({
            timeout: 1000 * 30,
            async: false,
            cache: false,
            type: 'GET',
            dataType: 'json',
            url: '/aw/api/v1/customers',
            contentType: 'application/json',
            data: {
                reserveNo: isEmpty(OLS.getSessionStorage("contractorReserveNo")) ? "" : OLS.getSessionStorage("contractorReserveNo")
            },
            success: function (data) {
                accountInfo = data;
                // ログインタイプの設定
                OLS.setSessionStorage("loginType", accountInfo.login_type);

                if (accountInfo.login_type == "1") {
                    //機種契約番号ログイン
                    isTerminal = true;
                } else {
                    isTerminal = false;
                }
                if (accountInfo.c_no_new_kbn == "1") {
                    // C#あり
                 isSb = false;
                }

                // null→””
                accountInfo.first_name = nullToEmpty(accountInfo.first_name);
                accountInfo.last_name = nullToEmpty(accountInfo.last_name);
                accountInfo.first_name_kana = nullToEmpty(accountInfo.first_name_kana);
                accountInfo.last_name_kana = nullToEmpty(accountInfo.last_name_kana);

                // 本申込判断
                if (isEmpty(params.applType)) {
                    if (!isEmpty(OLS.getSessionStorage("reservationInfo"))) {
                        // 予約情報を設定
                        OLS.setReserveInfo(OLS.getSessionStorage("reservationInfo"));
                    } else {
                        // 通常申込
                        OLS.proceed('deviceSelect');
                    }
                } else {
                    if (params.sb == "N") {
                        // 非SB本申込
                        OLS.reserveLogin();
                    } else {
                        // SB本申込
                        OLS.getSbReserveInfo();
                    }
                }

                // 住所コードが期限切れ、住所コードが一部未確定、先頭2桁が都道府県ではないの場合、本人確認が必要となります
                if (accountInfo.address_hand_input_flag) {
                    $("#send-to-div").hide();
                    // 「本人確認をする」ボタン と ボタン上部文言が表示しない
                    $(".contradictPtb").hide();
                    // 20211215追加認証の廃止  「本人確認をする」ボタン自体廃止、住所欄をはじめから表示ため
                    setTimeout(function(){
                        $("#otherAddress").click().prop("checked", true);
                    }, 500);
                }

                // 認証種別が回線認証かつFace認証以外の場合
                if (AUTHENTICATION_CATEGORY.IP != accountInfo.authentication_category
                    && AUTHENTICATION_CATEGORY.FACE != accountInfo.authentication_category ) {
                    $(".otherAddressElement").hide();
                }

                // 契約者住所欄への書き込み
                $('#contractorAddressDispname').append('〒' + data.post_code + '<br>' + data.address);
            },
            beforeCommonErrorModalShow: function (data, textStatus, jqXHR) {

                // 回線認証の場合
                if (UA.isSmartDevice) {
                    if (!isEmpty(jqXHR.responseJSON) &&
                        !isEmpty(jqXHR.responseJSON.error) &&
                        !isEmpty(jqXHR.responseJSON.error.code)) {

                        // 排他チェックエラーの判定
                        if (g_exclusion_MsgList[jqXHR.responseJSON.error.code]) {
                            reAuthFlag = true;
                        }
                    }
                }

                // 業務エラーが発生した場合、ポップアップ表示する前に、前画面に遷移する
                // 本申し込み判定
                if (!isEmpty(params.applType)) {
                    // 予約本申し込み
                    OLS.proceed('login');
                } else {
                    // 最初の画面
                    OLS.proceed('top');
                }
            }
        });
    }

};
